import { useEffect, useState } from 'react';
import { announceSetting, getSetting, listenToSetting, setSetting } from '../utils/settings';

// Returns [value, toggle, set]: `set(on)` for a caller that needs a value rather than a flip
const useBooleanSetting = (key, defaultValue = false) => {
  const [value, setValue] = useState(() => {
    const stored = getSetting(key);

    if (stored === undefined || stored === null) {
      // Persist the default on first run so it's explicit going forward
      if (defaultValue) setSetting(key, defaultValue);

      return defaultValue;
    }
    return stored === true;
  });

  // Another hook on the same key changed it
  useEffect(() => listenToSetting(key, (stored) => setValue(stored === true)), [key]);

  const set = (newValue) => {
    setValue(newValue);
    setSetting(key, newValue);
    announceSetting(key, newValue);
  };

  const toggle = () => set(!value);

  return [value, toggle, set];
};

export default useBooleanSetting;
